import { render, staticRenderFns } from "./ProductOrderSdsULDocumentPopUp.vue?vue&type=template&id=1799732c&scoped=true&"
import script from "./ProductOrderSdsULDocumentPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductOrderSdsULDocumentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderSdsULDocumentPopUp.vue?vue&type=style&index=0&id=1799732c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1799732c",
  null
  
)

export default component.exports